import { PairInfo } from '../constants'

export const formatSize = (size: bigint, pairInfo: PairInfo) => {
  const digits = BigInt(pairInfo.base.decimals - 3)

  if (size < 0n) return 0n

  return (size / 10n ** digits) * 10n ** digits
}
